
import { mapGetters,mapActions } from 'vuex'
export default {
  props: {
    // eslint-disable-next-line vue/prop-name-casing
    id: {
      default: 'faqs',
      type: String
    },
    header: {
      default: 'Frequently Asked <strong>Questions</strong>',
      type: String,
    },
  },
  data(){
    return{
      // FAQModalShow:false
      answers:[],
      ready:false
    }
  },
  // head() {
  //     if(this.ready){
  //       return {
  //           script: [{ type: 'application/ld+json', json: this.structuredData }]
  //       }
  //     }
  //   },
  computed: {
    ...mapGetters({
      activeModal : 'pages/getActiveModal',
    }),
    // FOR SCHEMA
  //   slot() {
  //     // const answers = []
  //     console.log(this.$refs.mySlot.textContent)
  //     const faqs =  this.$refs.mySlot.textContent.replace(/\n/g,'').split('   ')
  //     if (faqs[0] === ''){
  //       faqs.shift()
  //     }

  //     return faqs
  //   },
  //   questions() {
  //     const questions = []
  //     this.slot.forEach((qOrA) => {
  //       if (qOrA.includes(" Q. ")){
  //         const question = qOrA.replace(' Q. ','')
  //         questions.push(question)
  //       }
  //       else{
  //         const answer = qOrA.replace('A. ','')
  //         this.answers.push(answer)
  //       }
  //     })
  //     return questions
  //   },
  //   faqs() {
  //     const faqList = []
  //     this.questions.forEach((question, index) => {
  //       faqList.push({
  //         "@type": "Question",
  //         "name": question,
  //         "acceptedAnswer": {
  //           "@type":"Answer",
  //           "text": this.answers[index]
  //         }
  //       })
  //     })
  //     return faqList
  //   },
  //   structuredData() {
  //     return {
  //       "@context": "https://schema.org",
  //       "@type": "FAQPage",
  //       "mainEntity": this.faqs
  //     }
  //   }
  },
  // mounted() {
  //     this.ready = true
  //   },
  methods: {
    ...mapActions({
      updateActiveModal: 'pages/updateActiveModal', // map `this.add()` to `this.$store.commit('increment')`
    }),
    hideModal(){
      this.updateActiveModal(null)
      console.log('Active Modal: ',this.activeModal)
    }
  },
  render() {
    const slot = this.$slots.default
    //  return slot.text.replace(/,/g, "")
    return slot
  }

}
